/**
 * @author Fernando FH
 * @company Erillam Healthcare
 * @version 1.0
 */

import ServicePath from "@/core/ServicePath"
import {
  MainRequest
} from "@/core/request";

export default class ReportPDFRequest extends MainRequest {

  static downloadQR(object) {
    this.postPDFSEC(ServicePath.REPORT_MIESTUDIO_QR, object).then(
      (response) => {
        const url = URL.createObjectURL(
          new Blob([response.data], {
            type: "application/pdf",
          })
        );
        window.open(url);
      }
    );
  }
  

  static downloadInterpretation(object) {
    this.postPDFSEC(ServicePath.GET_REPORT_INTERPRETATION, object).then((response) => {
        const url = URL.createObjectURL(new Blob([response.data], {
          type: 'application/pdf'
        }))
        window.open(url);
    });
  }

  static downloadInterpretationByID(object) {
    this.postPDFSEC(ServicePath.GET_REPORT_INTERPRETATION_STUDY, object).then((response) => {
        const url = URL.createObjectURL(new Blob([response.data], {
          type: 'application/pdf'
        }))
        window.open(url);
    });
  }

  static getReportLaboratoryResults(params) {
    return this.postPDFSEC(ServicePath.GET_REPORT_INTERPRETATION_STUDY, params);
  }

  static downloadInterpretation1(object) {
    return this.postPDFSEC(ServicePath.GET_REPORT_INTERPRETATION, object);
  }

  static downloadConsultation(object) {

    this.postPDFSEC(ServicePath.GET_REPORT_CONSULTATION, object).then((response) => {
      const url = URL.createObjectURL(new Blob([response.data], {
        type: 'application/pdf'
      }))
      window.open(url);
      // var a = document.createElement("a");
      // document.body.appendChild(a);
      // a.style = "display: none";
      // let url = window.URL.createObjectURL(new Blob([response.data], {
      //   type: "'application/pdf"
      // }));
      // a.href = url;
      // a.download = object.fileName + ".pdf";
      // a.click();
      // window.URL.revokeObjectURL(url);
    });
  }

  static downloadConsultation1(object) {
    return this.postPDFSEC(ServicePath.GET_REPORT_CONSULTATION, object);
  }

  static downloadInterpreters(object) {
    return this.postPDFSEC(ServicePath.GET_REPORT_INTERPRETERS, object);
    // this.postPDFSEC(ServicePath.GET_REPORT_INTERPRETERS, object).then((response) => {
    //   const url = URL.createObjectURL(new Blob([response.data], {
    //     type: 'application/pdf'
    //   }))
    //   window.open(url);
    // });
  }

  static downloadPrescription(object, that) {
  return  this.postPDFSEC(ServicePath.GET_REPORT_PRESCRIPTION, object)
  .then((response) => {
      const url = URL.createObjectURL(new Blob([response.data], {
        type: 'application/pdf'
      }))
      window.open(url);
    }).catch((error) => {}).finally(() => {that.sending = false, that.loader = false})
  }

  static downloadReportedDiscarded(object) {
    return this.postPDFSEC(ServicePath.REPORT_STUDIES_REPORTED_DISCARDED, object);
    // this.postPDFSEC(ServicePath.REPORT_STUDIES_REPORTED_DISCARDED, object).then((response) => {
    //   const url = URL.createObjectURL(new Blob([response.data], {
    //     type: 'application/pdf'
    //   }))
    //   window.open(url);
    // });
  }

  static downloadClinicalEvent(object) {
    return this.postPDFSEC(ServicePath.REPORT_CLINICAL_EVENT, object);
    /*.then((response) => {
      const url = URL.createObjectURL(new Blob([response.data], {
        type: 'application/pdf'
      }))
      window.open(url);
    });*/
  }

  static downloadBarcodeLaboratory(object) {
    return this.postPDFSEC(ServicePath.REPORT_BARCODE_LABORATORY, object).then((response) => {
      const url = URL.createObjectURL(new Blob([response.data], {
        type: 'application/pdf'
      }))
      window.open(url);
    });
  }

  static downloadInterpretationXLS(object) {
    return this.postPDFSEC(ServicePath.REPORT_PRESCRIPTION_XLSX, object);
  }

  static downloadLaboratoryXLS(object) {
    return this.postPDFSEC(ServicePath.REPORT_LABORATORY, object);
  }

  // static downloadDentalXLS(object) {
  //   return this.postPDFSEC(ServicePath.REPORT_DENTAL, object);
  // }

  static downloadDentalPDF(object) {
    return this.postPDFSEC(ServicePath.REPORT_DENTAL, object);
  }

  static downloadReportXLSX(object) {
    return this.postPDFSEC(ServicePath.REPORT_STUDIES_REPORTED_DISCARDED_XLSX, object);
  }
  static downloadReportPrescriptionsXLSX(object) {
    return this.postPDFSEC(ServicePath.REPORT_PRESCRIPTIONS_XLSX, object);
  }
  static downloadReportPrescription(object) {
    return this.postPDFSEC(ServicePath.REPORT_PRESCRIPTIONS, object);
  }

  static downloadTempletateModalities() {
    return this.postPDFSEC(ServicePath.EXPORT_MODALITY);
  }
  static importTempletateModalities(object) {
    return this.postPDFSEC(ServicePath.IMPORT_MODALITY, object);
  }
  /**
   * PHARMACY REPORT
   *  
   */

  static downloadPharmacyDetailed(object) {
    return this.postPDFSEC(ServicePath.REPORT_PHARMACY_DETAILED_PDF, object);
  }

  static downloadPharmacyCondensed(object) {
    return this.postPDFSEC(ServicePath.REPORT_PHARMACY_CONDENSED_PDF, object);
  }


  /**
   * @autor Jesus R. Nava Cruz
   * * IMPORT / EXPORT TEMPLETES
   */

  /**
   * * ANTECEDENT 
   */
  static exportTempleteAntecedent() {
    return this.postPDFSEC(ServicePath.EXPORT_ANTECEDENT)
  }

  static importTempleteAntecedents(object) {
    return this.postPDFSEC(ServicePath.IMPORT_ANTECEDENT, object)
  }

  /**
   * * CONSULTING ROOM
   */
  static exportTempleteConsultingRoom() {
    return this.postPDFSEC(ServicePath.EXPORT_CONSULTING_ROOM)
  }

  static importTempleteConsultingRoom(object) {
    return this.postPDFSEC(ServicePath.IMPORT_CONSULTING_ROOM, object)
  }

  /**
   * * MODALITY STUDY
   */
  static exportTempleteModalityStudy() {
    return this.postPDFSEC(ServicePath.EXPORT_MODALITY_STUDY)
  }

  static importTempleteModalityStudy(object) {
    return this.postPDFSEC(ServicePath.IMPORT_MODALITY_STUDY, object)
  }

  /**
   * * ROLE
   */
  static exportTempleteRole() {
    return this.postPDFSEC(ServicePath.EXPORT_ROLE)
  }

  static importTempleteRole(object) {
    return this.postPDFSEC(ServicePath.IMPORT_ROLE, object)
  }

  /**
   * * BRANCH OFFICE
   */
  static exportTempleteBranchOffice(){
    return this.postPDFSEC(ServicePath.EXPORT_BRANCH_OFFICE);
  }
  static exportPatient(data){
    return this.postPDFSEC(ServicePath.REPORT_PATIENT, data);
  }
  
  static exportLaboratoriy(data){
    return this.postPDFSEC(ServicePath.REPORT_LABORATORY_EXCEL, data);
  }

  static exportWarehouse(data){
    return this.postPDFSEC(ServicePath.REPORT_WAREHOUSE, data);
  }

  static exportDecrease(data){
    return this.postPDFSEC(ServicePath.REPORT_DECREASE, data);
  }
  static exportlaboratory(data){
    return this.postPDFSEC(ServicePath.REPORT_DOWNLOAD_LABORATORY, data);
  }

  static exportInterpretation(data){
    return this.postPDFSEC(ServicePath.REPORT_DOWNLOAD_INTERPRETATION, data);
  }
  /**
   * * @Mau de Pallares
   * * Excel interpretation
   */
  static exportHistoryInterpretationExcel(data){
    return this.postPDFSEC(ServicePath. REPORT_DOWNLOAD_EXCEL_HISTORY_INTERPRETATION, data);
  }
  static exportPendingInterpretationExcel(data){
    return this.postPDFSEC(ServicePath. REPORT_DOWNLOAD_EXCEL_PENDING_INTERPRETATION, data);
  }


  static exportDentalExcel(data){
    return this.postPDFSEC(ServicePath.REPORT_EXCEL_DENTAL,data);
  }

  static exportConsultation(data){
    return this.postPDFSEC(ServicePath.REPORT_CONSULTATIONS,data);
  }
  static importTempleteBranchOffice(object){
    return this.postPDFSEC(ServicePath.IMPORT_BRANCH_OFFICE, object);
  }

  static getReportProductivity(object){
    return this.postZipSEC(ServicePath.DOWNLOAD_REPORT_PRODUCTIVITY, object);
  }

  static getReportProductivityRevalidation(object){
    return this.postZipSEC(ServicePath.DOWNLOAD_REPORT_PRODUCTIVITY, object);
  }

  static downloadDentalReport(object) {
    return this.postPDFSEC(ServicePath.REPORT_DENTAL_CONSULTATION, object);
  }

  static downloadOrderStudy(object) {
    return this.postPDFSEC(ServicePath.REPORT_ORDER_STUDY, object);
  }

  static downloadStartingOrder(object) {
    return this.postPDFSEC(ServicePath.REPORT_STARTING_ORDER, object);
  }

  static downloadWarehouseEntry(object) {
    return this.postPDFSEC(ServicePath.REPORT_WAREHOUSE_ENTRY, object);
  }

  static downloadStock(object) {
    return this.postPDFSEC(ServicePath.REPORT_STOCK, object);
  }

  static downloadClinicalHistory(object) {
    return this.postPDFSEC(ServicePath.REPORT_DOWNLOAD_CLINICAL_HISTORY, object);
  }

  static downloadOrderStudyReception(data) {
    return this.postPDFSEC(ServicePath.REPORT_DOWNLOAD_ORDER_STUDY_RECEPTION, data);
  }



}